// Bold, solid risk-category chip — used everywhere a package is shown so the
// Yellow/Orange mapping is spotted instantly.
export const RiskChip = ({ risk, hex, text, className = "" }) => (
  <span
    className={`inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wider shadow-sm ${className}`}
    style={{ backgroundColor: hex, color: text }}
    data-testid={`risk-chip-${risk.toLowerCase()}`}
  >
    <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: text }} />
    For {risk} risk
  </span>
);

export default RiskChip;
